import React from 'react';
import { STUDY_ANSWER_TEXT } from '../../constants/eyetrackingConstants';
import { summarizeStudyAnswer, type StudyAnswer } from './studyAnswer';

/** Researcher view of an embedded shopping study's stored result: one row per shelf, in shopped order. */
const StudyAnswerSummary: React.FC<{ answer: StudyAnswer }> = ({ answer }) => {
  const shelves = summarizeStudyAnswer(answer);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs text-gray-600">
        <span className="font-medium">{STUDY_ANSWER_TEXT.title}</span>
        <span>
          {STUDY_ANSWER_TEXT.quality}:{' '}
          <span className="font-semibold text-gray-900">
            {answer.quality_grade ?? STUDY_ANSWER_TEXT.notAvailable}
          </span>
        </span>
      </div>
      <div className="divide-y divide-gray-100 rounded border border-gray-200 bg-white">
        {shelves.map((s, i) => (
          <div
            key={`${s.shelf}-${i}`}
            className="flex flex-wrap items-baseline gap-x-3 gap-y-1 px-3 py-2 text-sm"
          >
            <span className="w-20 shrink-0 font-mono text-xs text-gray-500">{s.shelf}</span>
            {s.bought ? (
              <span className="font-medium text-gray-900">
                <span className="text-gray-500 font-normal">{STUDY_ANSWER_TEXT.bought}: </span>
                {s.bought}
              </span>
            ) : (
              <span className="text-amber-700">{STUDY_ANSWER_TEXT.nothing}</span>
            )}
            {s.putBack.length > 0 && (
              <span className="text-xs text-gray-500">
                {STUDY_ANSWER_TEXT.putBack}: {s.putBack.join(', ')}
              </span>
            )}
            {s.seconds !== null && (
              <span className="ml-auto text-xs tabular-nums text-gray-400">
                {s.seconds}
                {STUDY_ANSWER_TEXT.seconds}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudyAnswerSummary;
